import { createCanvasAdapter } from './canvasAdapter'

export function createResourceManager(options = {}) {
  const { canvasAdapter = null } = options
  const adapter = canvasAdapter || createCanvasAdapter({ preferOffscreen: true })

  const canvases = new Set()
  const canvasOptions = new WeakMap()
  const rafIds = new Set()
  const disposables = new Set()
  let _disposed = false

  function createCanvas(width = 1, height = 1) {
    const c = adapter.createCanvas(width, height)
    canvases.add(c)
    return c
  }

  function registerCanvas(canvas, opts = {}) {
    if (!canvas) return
    canvases.add(canvas)
    if (opts && typeof opts === 'object') {
      canvasOptions.set(canvas, { ...opts })
    }
  }

  function trackRaf(id) {
    if (typeof id === 'number') rafIds.add(id)
  }

  function registerDisposable(d) {
    if (!d) return
    disposables.add(d)
  }

  function dispose() {
    if (_disposed) return
    _disposed = true
    // cancel animation frames
    for (const id of rafIds) {
      try {
        cancelAnimationFrame(id)
      } catch (err) {
        console.debug('[resourceManager] cancelAnimationFrame error', err)
      }
    }
    rafIds.clear()

    // clear canvases
    for (const c of canvases) {
      const opts = canvasOptions.get(c) || {}
      if (opts.skipZero === true) continue
      try {
        c.width = 0
        c.height = 0
      } catch (err) {
        console.debug('[resourceManager] zero canvas error', err)
      }
    }
    canvases.clear()
    canvasOptions.clear()

    // call any registered disposables
    for (const d of disposables) {
      try {
        if (typeof d.dispose === 'function') d.dispose()
        else if (typeof d === 'function') d()
      } catch (err) {
        console.debug('[resourceManager] disposable error', err)
      }
    }
    disposables.clear()
  }

  return {
    createCanvas,
    registerCanvas,
    trackRaf,
    registerDisposable,
    dispose,
    _internal: { adapter }
  }
}

export default { createResourceManager }
